import React, { useState, useEffect } from "react";
import "./integrations.css";
import { globalFont } from "../../utils/RepeatFunctions/Schedule";
import axiosInstance from "../../../axios/axios";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";

import { BsCheckCircle } from "react-icons/bs";
import { IoCloseSharp } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import { Div1, ModalShow, ModalCont } from "../PatientPortalSettings/styles";
import { Popup } from "semantic-ui-react";
import GetStartedPopup from "../../popups/GetStartedPopup";

/* -------------------- VENDOR CONFIG -------------------- */

const vendorConfig = {
  Twilio: {
    ACCOUNT_SID: "TWILIO_ACCOUNT_SID",
    AUTH_TOKEN: "TWILIO_AUTHTOKEN",
    FROM: "TWILIO_FROM",
    USERNAME: "TWILIO_PHONE_GATEWAY_USERNAME",
    PASSWORD: "TWILIO_PHONE_GATEWAY_PASSWORD",
    URL: "TWILIO_PHONE_GATEWAY_URL",
  },
  RingCentral: {
    ACCOUNT_SID: "RINGCENTRAL_ACCOUNT_SID",
    AUTH_TOKEN: "RINGCENTRAL_AUTHTOKEN",
    FROM: "RINGCENTRAL_FROM",
    USERNAME: "RINGCENTRAL_PHONE_GATEWAY_USERNAME",
    PASSWORD: "RINGCENTRAL_PHONE_GATEWAY_PASSWORD",
    URL: "RINGCENTRAL_PHONE_GATEWAY_URL",
  },
};

export default function TwilioRingIntegrationModal({
  vendor,
  onClose,
  setConnected,
  openNextPopup,
  mode,
  isIntegrationStep3,
  onBackStep3,
  onNextStep3,
  isIntegrationStep5,
  onBackStep5,
  onNextStep5,
  showReminderIntro4,
  onReminderBack,
  onReminderNext,
  onReminderClose,
}) {
  const config = vendorConfig[vendor];

  const storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");

  const initialState = {
    account_sid: "",
    auth_token: "",
    from_name: "",
    gateway_username: "",
    gateway_password: "",
    gateway_url: "",
  };

  const [formData, setFormData] = useState(initialState);
  const [initialValues, setInitialValues] = useState(initialState);

  const [ModalAlerShow, setModalAlerShow] = useState(false);
  const [ModalAlerShow1, setModalAlerShow1] = useState(false);
  const [AlertMsg, setAlertMsg] = useState("");
  const [errors, setErrors] = useState({});
  const [isConnected, setIsConnected] = useState(false);

  const fields = [
    { label: `${vendor} Account Sid`, name: "account_sid" },
    { label: `${vendor} Auth Token`, name: "auth_token" },
    { label: `${vendor} From Name`, name: "from_name" },
    { label: "Phone Gateway Username", name: "gateway_username" },
    { label: "Phone Gateway Password", name: "gateway_password" },
    { label: "Phone Gateway URL", name: "gateway_url" },
  ];

  /* -------------------- CHANGE HANDLER -------------------- */

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  /* -------------------- FETCH EXISTING CONFIG -------------------- */

  const getIntegrationInfo = async () => {
    const res = await axiosInstance.get("/vozo/NotificationSetting");
    const data = Decrypt_Value(res.data, "vozo");

    const values = {
      account_sid:
        data.find((d) => d.gl_name === config.ACCOUNT_SID)?.gl_value || "",
      auth_token:
        data.find((d) => d.gl_name === config.AUTH_TOKEN)?.gl_value || "",
      from_name: data.find((d) => d.gl_name === config.FROM)?.gl_value || "",
      gateway_username:
        data.find((d) => d.gl_name === config.USERNAME)?.gl_value || "",
      gateway_password:
        data.find((d) => d.gl_name === config.PASSWORD)?.gl_value || "",
      gateway_url: data.find((d) => d.gl_name === config.URL)?.gl_value || "",
    };

    const connected = !!values.account_sid && !!values.auth_token;

    setIsConnected(connected);
    setFormData(values);
    setInitialValues(values);
  };

  /* -------------------- CHANGE CHECK -------------------- */

  const checkForChanges = () => {
    return Object.keys(formData).some(
      (key) => formData[key] !== initialValues[key],
    );
  };

  const validateFields = () => {
    let newErrors = {};

    if (!formData.account_sid.trim()) {
      newErrors.account_sid = "Account SID is required";
    } else if (formData.account_sid.trim().length < 10) {
      newErrors.account_sid = "Account SID must be at least 10 characters";
    }

    if (!formData.auth_token.trim()) {
      newErrors.auth_token = "Auth Token is required";
    } else if (formData.auth_token.trim().length < 10) {
      newErrors.auth_token = "Auth Token must be at least 10 characters";
    }

    if (!formData.from_name.trim()) {
      newErrors.from_name = "From Name is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  /* -------------------- SUBMIT -------------------- */

  const handleSubmit = async () => {
    if (!validateFields()) return;
    if (!checkForChanges()) {
      setAlertMsg("No changes detected to Save");
      setModalAlerShow1(true);

      setTimeout(() => setModalAlerShow1(false), 3000);
      return;
    }

    const payload = [
      {
        glname: config.ACCOUNT_SID,
        glindex: "0",
        glvalue: formData.account_sid,
      },
      { glname: config.AUTH_TOKEN, glindex: "0", glvalue: formData.auth_token },
      { glname: config.FROM, glindex: "0", glvalue: formData.from_name },
      {
        glname: config.USERNAME,
        glindex: "0",
        glvalue: formData.gateway_username,
      },
      {
        glname: config.PASSWORD,
        glindex: "0",
        glvalue: formData.gateway_password,
      },
      { glname: config.URL, glindex: "0", glvalue: formData.gateway_url },
      { glname: "VENDOR_METHOD", glindex: "0", glvalue: vendor },
    ];

    const encrypted = Encrypt_Value(payload, "vozo");

    await axiosInstance.put("/vozo/settingsecurity", encrypted);

    // setAlertMsg(
    //   mode === "edit" ? "Saved successfully" : "Connected successfully",
    // );
    // setModalAlerShow(true);
    if (!isIntegrationStep3 && !isIntegrationStep5) {
      setAlertMsg(
        mode === "edit" ? "Saved successfully" : "Connected successfully",
      );
      setModalAlerShow(true);
    }

    // setTimeout(() => {
    //   setModalAlerShow(false);
    //   setConnected(true);

    //   onClose();
    //   if (mode !== "edit" && openNextPopup) {
    //     setTimeout(() => openNextPopup(), 700);
    //   }
    // }, 2000);

    setTimeout(() => {
      if (!isIntegrationStep5) {
        setModalAlerShow(false);
      }

      setConnected(true);
      if (isIntegrationStep3) {
        onNextStep3 && onNextStep3();
      } else if (isIntegrationStep5) {
        onNextStep5 && onNextStep5();
      } else {
        onClose();

        if (mode !== "edit" && openNextPopup) {
          setTimeout(() => openNextPopup(), 700);
        }
      }
    }, 2000);
  };

  // useEffect(() => {
  //   if (mode === "edit") {
  //     getIntegrationInfo();
  //   } else {
  //     setFormData(initialState);
  //     setInitialValues(initialState);
  //   }
  // }, [vendor, mode]);
  useEffect(() => {
    if (mode === "edit" || isIntegrationStep3 || isIntegrationStep5) {
      getIntegrationInfo();
    } else {
      setFormData(initialState);
      setInitialValues(initialState);
      setIsConnected(false);
    }
  }, [vendor, mode, isIntegrationStep5]);

  useEffect(() => {
    let timeout;
    if (isIntegrationStep3 || isIntegrationStep5) {
      timeout = setTimeout(() => {
        const scrollY = window.scrollY;
        document.body.style.position = "fixed";
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = "100%";
        document.body.style.overflow = "hidden";
        document.body.dataset.scrollY = scrollY;
      }, 50);
    } else {
      if (document.body.style.position === "fixed") {
        const scrollY = document.body.dataset.scrollY;
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        document.body.style.overflow = "";
        window.scrollTo(0, parseInt(scrollY || "0"));
      }
    }
    return () => {
      clearTimeout(timeout);
      if (document.body.style.position === "fixed") {
        const scrollY = document.body.dataset.scrollY;
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        document.body.style.overflow = "";
        window.scrollTo(0, parseInt(scrollY || "0"));
      }
    };
  }, [isIntegrationStep3, isIntegrationStep5]);

  const headerTitle =
    vendor === "Twilio"
      ? "Appointment Reminder Configuration"
      : "Fax Integration";

  const isPopupOpen =
    !!isIntegrationStep3 || !!isIntegrationStep5 || !!showReminderIntro4;
  const isAccountSetupTwilioIntegrationOpen = !!showReminderIntro4;
  const popupTitle = isIntegrationStep3
    ? "Configure Twilio Integration"
    : isIntegrationStep5
      ? "Configure Fax Integration"
      : "Configure Appointment Reminder";
  const popupBullets = isIntegrationStep3
    ? [
        'When click on "Connect" button for Twilio a configuration popup will open.',
        'Enter the required configuration details and click on the "Connect" button to link the configuration.',
      ]
    : isIntegrationStep5
      ? [
          'When click on "Connect" button for Fax a configuration popup will open.',
          'Enter the required configuration details and click on the "Connect" button to link the configuration.',
        ]
      : [
          "In the Twilio Configuration popup enter the required details.",
          'Now click on the "Connect" button to confirm the configuration.',
        ];
  const popupStep = isIntegrationStep3 ? 3 : isIntegrationStep5 ? 5 : 4;
  const popupTotalSteps = showReminderIntro4 ? 6 : 13;
  const popupOnNext = isIntegrationStep3
    ? onNextStep3
    : isIntegrationStep5
      ? onNextStep5
      : onReminderNext;
  const popupOnBack = isIntegrationStep3
    ? onBackStep3
    : isIntegrationStep5
      ? onBackStep5
      : onReminderBack;
  const popupOnClose = showReminderIntro4 ? onReminderClose : onClose;

  return (
    <>
      <div className="integration-modal-overlay">
        <Popup
          offset={[-120, 5]}
          content={
            <GetStartedPopup
              title={popupTitle}
              bullets={popupBullets}
              currentStep={popupStep}
              totalSteps={popupTotalSteps}
              onNext={popupOnNext}
              onBack={popupOnBack}
              onClose={() => {
                if (popupOnClose) popupOnClose();
              }}
              width="340px"
            />
          }
          open={isPopupOpen}
          trigger={
            <div
              style={{ fontFamily: globalFont }}
              className="integration-modal-container"
            >
              <Modal.Header
                closeButton={!isAccountSetupTwilioIntegrationOpen}
                className="p-8"
                onHide={
                  isAccountSetupTwilioIntegrationOpen ? undefined : onClose
                }
              >
                <Modal.Title>{headerTitle}</Modal.Title>
              </Modal.Header>

              <div className="integration-modal-body  twilio-integration">
                {fields.map((field, index) => (
                  <div className="input-group" key={index}>
                    <label>{field.label}</label>
                    <input
                      type="text"
                      name={field.name}
                      value={formData[field.name]}
                      onChange={handleChange}
                    />
                    {errors[field.name] && (
                      <div className="errormessage">{errors[field.name]}</div>
                    )}
                  </div>
                ))}
              </div>

              <div className="integration-modal-footer">
                <button
                  className="integration-cancel-btn"
                  onClick={onClose}
                  disabled={isAccountSetupTwilioIntegrationOpen}
                >
                  Cancel
                </button>

                {/* <button
                  className="integration-connect-btn"
                  onClick={handleSubmit}
                  disabled={isAccountSetupTwilioIntegrationOpen || storedNames.setSchedulingPreferences_viewOnly}
                >
                  {mode === "edit" ? "Save" : "Connect"}
                </button> */}
                <button
                  className="integration-connect-btn"
                  onClick={handleSubmit}
                  // disabled={
                  //   storedNames.setSchedulingPreferences_viewOnly ||
                  //   (isIntegrationStep5 && isConnected)
                  // }
                  disabled={
                    storedNames.setSchedulingPreferences_viewOnly ||
                    ((isIntegrationStep3 || isIntegrationStep5) && isConnected)
                  }
                >
                  {(isIntegrationStep3 || isIntegrationStep5) && isConnected
                    ? "Connected"
                    : mode === "edit"
                      ? "Save"
                      : "Connect"}
                </button>
              </div>
            </div>
          }
          position="left center"
        />
      </div>

      {ModalAlerShow && (
        <ModalShow show={ModalAlerShow}>
          <Div1 position="relative" dis="flex" margin="0 auto" top="-5%">
            <ModalCont>
              <BsCheckCircle />
              <span>{AlertMsg}</span>
            </ModalCont>
          </Div1>
        </ModalShow>
      )}

      {ModalAlerShow1 && (
        <>
          <ModalShow show={ModalAlerShow1}>
            <div className="alert msg alert-danger" role="alert">
              <IoCloseSharp className="icons-bs" />
              {AlertMsg}
            </div>
          </ModalShow>
        </>
      )}
    </>
  );
}
